/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoMangimeDTO
 */
export interface TipoMangimeDTO {
    /**
     * 
     * @type {number}
     * @memberof TipoMangimeDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TipoMangimeDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the TipoMangimeDTO interface.
 */
export function instanceOfTipoMangimeDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TipoMangimeDTOFromJSON(json: any): TipoMangimeDTO {
    return TipoMangimeDTOFromJSONTyped(json, false);
}

export function TipoMangimeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoMangimeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
    };
}

export function TipoMangimeDTOToJSON(value?: TipoMangimeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'descrizione': value.descrizione,
    };
}

